module.exports = __webpack_public_path__ + "assets/align_all.b67e2523.svg";